import React from 'react';
import PhenoTypeAssesment from '../Assets/images/phenotype assessment.png';
import DoneIcon from '@mui/icons-material/Done';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import outerCircle from '../Assets/images/vector.png';
import PrakritiRotation from '../Assets/animations/Prakriti rotation 2.json';
import uq from '../Assets/images/unique positive traits icon.png'
import imp from '../Assets/images/Areas of improvement.png'
import dis from '../Assets/images/Disease predisposition.png'
import Lottie from 'lottie-react';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import ChatBot from '../Assets/images/Prakriti screen green circle.png'
import { useLocation, useNavigate } from 'react-router-dom';
import vikritinext from '../Assets/images/vikritinext.png'
import InfoIcon from '@mui/icons-material/Info';
import { toast, Zoom } from 'react-toastify';


function PrakritiIntro() {

    let navigate = useNavigate()

    const { state } = useLocation();

    const [open3, setOpen3] = useState(false);

    const handleClickOpen3 = () => {
        setOpen3(true);
    };

    const handleClose3 = () => {
        setOpen3(false);
    };

    return (
        <div className='Welcome-page-section'>

            <div className='prakriti-intro-section'>

                <div className="flex flex-row justify-between w-full h-full" >

                    <div className='p-5 m-5'>
                        <p className='pr-intro-t text-2xl'>Prakriti Assessment <span>
                            <IconButton onClick={handleClickOpen3}
                                style={{ color: "inherit" }}><InfoIcon style={{ color: "inherit" }} /></IconButton></span></p>
                        <p className='mt-5 pr-intro-text text-2xl text-/8 leading-8'>
                            Please answer the following questions
                            <br className="hidden sm:inline" />
                            based on your health and lifestyle as
                            <br className="hidden sm:inline" />
                            in 15-20 years old
                        </p>
                    </div>

                    <div>
                        <div className='background-animation'>
                            <Lottie
                                animationData={PrakritiRotation}
                                className='PrakritiRotationAnimation'
                            />
                        </div>
                    </div>

                </div>

                <div className='m-5' onClick={() => {
                    navigate('/prakriti', { state: { appointemntid: state?.appointemntid || '', } })
                }} style={{ alignSelf: "center", justifySelf: "flex-end", marginTop: "auto", width: "3rem", cursor: "pointer" }} >
                    <img src={vikritinext}></img>
                </div>
            </div>

            {/* <div className='Profile-img-section'>
                <div>Prakriti Assessment</div>
                <div><img src={PhenoTypeAssesment} alt="Personal Information" /></div>
            </div> */}

            {/* <div className='Prakriti-intro-main-section'>

                <div className='Prakriti-into-title'>

                    <div>
                        <img src={ChatBot}></img>
                    </div>

                    <div>
                        <p>
                            I am your Personalized Coach
                        </p>
                    </div>

                    <div style={{
                        justifySelf: "flex-end",
                        cursor: 'pointer',
                        borderBottom: "1px solid silver",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 400,
                    }} onClick={() => {
                        navigate('/')
                    }}>
                        <p>Skip now</p>
                    </div>

                </div>

                <div className='Prakriti-into-title-discription'>
                    <p>Prakriti</p>
                    <p>Prakriti refers to an individual's unique constitution of <br />
                        physical, mental, and emotional traits, which influences <br />
                        their health, and overall well-being.</p>
                </div>

                <div className='Prakriti-into-detailed-discription'>
                    <p>Through this assessment, discover your</p>
                    <div>

                        <div>
                            <img src={uq}></img>
                            <p>Unique Positive Traits</p>

                        </div>

                        <div>
                            <img src={imp}></img>
                            <p>Areas of Improvement</p>

                        </div>

                        <div>
                            <img src={dis}></img>
                            <p>Disease Predisposition</p>
                        </div>
                    </div>

                </div>

                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center", width: '100%'
                }}>
                    <div className='phenotypebtn'>
                        <p>Let’s do your unique <b>One Time Phenotype <br />Assessment</b></p>
                    </div>
                    <Button
                        style={{
                            textTransform: 'none',
                            borderRadius: '0',
                            backgroundColor: '#DA6E0B',
                            color: 'white',
                            border: 'none',
                            boxSizing: 'border-box',
                            borderRadius: '5px',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: '10px',
                            paddingRight: "2rem",
                            paddingLeft: "2rem"
                        }}

                        onClick={() => {
                            navigate('/Prakriti')
                            toast.info("Please answer the following questions based on your health and lifestyle as a 15-20-year-old", {
                                position: 'top-center',
                                limit: 1,
                                transition: Zoom,
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: 'dark'
                            });
                        }}

                    >
                        Start Your Assesment
                    </Button>
                </div>
                <div className='background-animation'>
                    <Lottie
                        animationData={PrakritiRotation}
                        className='PrakritiRotationAnimation'
                    />
                </div>
            </div> */}




            <Dialog
                open={open3}
                onClose={handleClose3}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: { borderRadius: '10px', overflow: 'hidden' }
                }}
            >
                <DialogContent className='cpndialogbg' style={{ backgroundColor: "#FFFFFF" }}>

                    <div className='flex justify-end'>
                        <IconButton onClick={handleClose3}>
                            <CloseIcon></CloseIcon>
                        </IconButton>
                    </div>

                    <div className='flex flex-col items-center gap-3 justify-center'>
                        <div className='m-5'>
                            <p className='pr-intro-t text-2xl'>Prakriti ?
                            </p>
                            <p className='mt-5 pr-intro-text text-2xl text-/8 leading-8'>
                                An individual's unique constitution of physical, mental, and emotional traits, which influences their health, and overall well-being
                            </p>
                        </div>

                    </div>
                </DialogContent>
            </Dialog>


        </div>
    );
}

export default PrakritiIntro;
